var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 3.75c0.4125 0 0.75 0.3375 0.75 0.75v14.99l-0.2344-0.3047-6.375-8.25c-0.2109-0.2766-0.5437-0.4359-0.8906-0.4359-0.3469 0-0.675 0.1594-0.8906 0.4359l-3.891 5.034-1.43-2.002c-0.2109-0.2953-0.5484-0.4688-0.9141-0.4688-0.3656 0-0.7031 0.1734-0.9141 0.4734l-3.75 5.25-0.2109 0.2906v-15.01c0-0.4125 0.3375-0.75 0.75-0.75zm-18-2.25c-1.655 0-3 1.345-3 3v15c0 1.655 1.345 3 3 3h18c1.655 0 3-1.345 3-3v-15c0-1.655-1.345-3-3-3zm3.75 9c0.8038 0 1.547-0.4288 1.949-1.125 0.4019-0.6962 0.4019-1.554 0-2.25-0.4019-0.6962-1.145-1.125-1.949-1.125-1.243 0-2.25 1.007-2.25 2.25 0 1.243 1.007 2.25 2.25 2.25z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.a8eb44cd8e4ed625a6b9a707a162ba9b.svg";
export { ForwardRef as ReactComponent };